import React, { FC } from 'react'
import {
  createStyles,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core'
import Loader from '@root-gipro/shared/Loader/Loader'
import ProjectRpcRow from '@root-gipro/modules/userProjects/components/Project/ProjectRpc/ProjectRpcRow'

interface IAdminSolutionsTable {
  objectsAnalog: any
  loadingObjectsAnalogPage: boolean
}

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      '& .MuiTableCell-root': {
        padding: '6px 12px',
        lineHeight: '18px',
        height: '61px'
      },
    },
    textWithIcon: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      '&:hover $sortIcon': {
        transform: 'scale(1.2)',
        color: '#1976d2',
      },
    },
  })
)

const ProjectRpcTable: FC<IAdminSolutionsTable> = ( {
  objectsAnalog,
  loadingObjectsAnalogPage,
}) => {

  const classes = useStyles();

  return (
    <TableContainer
      component={Paper}
      className={classes.root}
      style={{ marginBottom: '30px' }}
    >
      <div style={{ width: '100%', overflowX: 'auto', height: 'auto' }}>
        <Table
          size='small' stickyHeader
          aria-label='admin panel table'
        >
          <TableHead>
            <TableRow>
              <TableCell
                style={{ width: '10%' }}
                align='center'
              >
                Действия
              </TableCell>

              <TableCell
                align='center'
                style={{ width: '10%' }}
                className={classes.root}
              >
								<span
                  className={classes.textWithIcon}
                >
									Номер
								</span>
              </TableCell>

              <TableCell style={{ width: '35%' }}>
								<span
                  className={classes.textWithIcon}
                >
									Наименование объекта-аналога
								</span>
              </TableCell>

              <TableCell
                style={{ width: '20%' }}
                align='center'
              >
								<span
                  className={classes.textWithIcon}
                >
									Название ТХ
								</span>
              </TableCell>

              <TableCell
                style={{ width: '10%' }}
                align='center'
              >
                Количество
              </TableCell>

              <TableCell
                style={{ width: '15%' }}
                align='center'
              >
                Комментарий
              </TableCell>

              <TableCell
                style={{ width: '10%' }}
                align='center'
              >
                Единица измерения
              </TableCell>

              <TableCell
                style={{ width: '20%' }}
                align='center'
              >
                Итого по главам 1-12, тыс. руб. с НДС
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loadingObjectsAnalogPage ? (
              <tr>
                <td
                  colSpan={100}
                  style={{ textAlign: 'center', padding: '10px' }}
                >
                  <Loader />
                </td>
              </tr>
            ) : objectsAnalog?.length ? (
              objectsAnalog.map((objectAnalog: any) => {

                return (
                  <ProjectRpcRow
                    key={objectAnalog.id}
                    objectAnalog={objectAnalog}
                  />
                )
              })
            ) : (
              <tr>
                <td
                  colSpan={100}
                  style={{ textAlign: 'center', padding: '10px' }}
                >
                  Нет данных для отображения
                </td>
              </tr>
            )}
          </TableBody>
        </Table>
      </div>
    </TableContainer>
  )
}

export default ProjectRpcTable;
